import { render, staticRenderFns } from "./trademark-thats-not-all-btn.vue?vue&type=template&id=d54997fc"
import script from "./trademark-thats-not-all-btn.vue?vue&type=script&lang=js"
export * from "./trademark-thats-not-all-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports